import pl from "@locales/patient/program_preview/pl.json";
import en from "@locales/patient/program_preview/en.json";

export default {
  pl: pl,
  en: en,
};
